import { useMemo, useState } from 'react';
import { FaRegCalendar } from 'react-icons/fa6';
import { IoIosArrowBack } from 'react-icons/io';
import { isAfter, isSameDay } from 'date-fns';
import Text from '../../kit/text/Text';
import Button from '../../kit/button/Button';
import CalendarSmall from '../../kit/calendar-small/CalendarSmall';
import { getCurrentDay } from 'src/app/utils/calendar.utils';
import styles from './Header.module.css';
import Link from '../../kit/link/Link';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'src/types/app-routes.enum';
import { useAppContext } from 'src/app/state';
import { PiPencilSimpleBold } from 'react-icons/pi';

const Header = () => {
  const navigate = useNavigate();
  const {
    state: { migraineAttacks },
  } = useAppContext();
  const [selectedDay, setSelectedDay] = useState<Date>(new Date());
  const month = useMemo(() => getCurrentDay(new Date()).month, []);
  const attackDays: Date[] = useMemo(
    () =>
      migraineAttacks
        .filter((record) => record.isMigraineDay)
        .map((attack) => attack.date!),
    [migraineAttacks]
  );
  const vyduraPerAttackDays: Date[] = useMemo(
    () =>
      migraineAttacks
        .filter((attack) => attack.vyduraPerAttack === true)
        .map((attack) => attack.date!),
    [migraineAttacks]
  );
  const vyduraEveryOtherDayDays: Date[] = useMemo(
    () =>
      migraineAttacks
        .filter((attack) => attack.vyduraEveryOtherDay === true)
        .map((attack) => attack.date!),
    [migraineAttacks]
  );
  const isOngoingAttack = useMemo(
    () => attackDays.some((day) => isSameDay(day!, selectedDay)),
    [attackDays, selectedDay]
  );
  const isVyduraIntakeDay = useMemo(
    () => vyduraEveryOtherDayDays.some((day) => isSameDay(day!, selectedDay)),
    [vyduraEveryOtherDayDays, selectedDay]
  );
  const openMigraineRecordPage = () => {
    const params = new URLSearchParams();
    params.set('day', selectedDay.toDateString());
    navigate(`${AppRoutes.MigraineAttack}?${params.toString()}`);
  };
  const openVyduraIntakePage = () => {
    const params = new URLSearchParams();
    params.set('day', selectedDay.toDateString());
    navigate(`${AppRoutes.VyduraIntake}?${params.toString()}`);
  };
  const openCalendar = () => {
    const params = new URLSearchParams();
    params.set('day', selectedDay.toDateString());
    navigate(`${AppRoutes.Calendar}?${params.toString()}`);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles['decorated-wrapper']}>
        <div className={styles.header}>
          <Link link='https://www.figma.com/design/7SSqDxwLJKu1uzqRAqnIPg/Vydura-D2P-2.1?node-id=117-11131&t=aiUI0n9TrhqaXdNs-0'>
            <IoIosArrowBack color='white' />
          </Link>
          <div
            className={styles.flex}
            onClick={openCalendar}
            style={{ cursor: 'pointer' }}
          >
            <FaRegCalendar color='white' size={24} />
            <Text style={{ color: 'white' }}>&nbsp;&nbsp;{month}</Text>
          </div>
        </div>
        <div className={styles.content}>
          <CalendarSmall
            attackDays={attackDays}
            vyduraPerAttack={vyduraPerAttackDays}
            vyduraEveryOtherDay={vyduraEveryOtherDayDays}
            selectedDay={selectedDay}
            handleSelectDay={setSelectedDay}
          />
          <Text tag='h2' size='m-large' weight='bold' centered>
            Feel good, for good
          </Text>
          {!isAfter(selectedDay, new Date()) && (
            <Button
              type={isOngoingAttack ? 'white' : 'primary'}
              width='content-width'
              onClick={openMigraineRecordPage}
              style={{
                display: 'flex',
                alignItems: 'center',
                border: isOngoingAttack ? '1px solid white' : 'none',
                color: 'white',
                background: isOngoingAttack ? 'transparent' : undefined,
              }}
            >
              {isOngoingAttack ? (
                <>
                  <PiPencilSimpleBold />
                  &nbsp;&nbsp;
                  {`Edit${isSameDay(selectedDay, new Date()) ? ' ongoing ' : ' '}attack`}
                </>
              ) : (
                '+ Record attack'
              )}
            </Button>
          )}
          {!isOngoingAttack && isVyduraIntakeDay && (
            <Button
              type='transparent'
              width='content-width'
              onClick={openVyduraIntakePage}
              style={{
                display: 'flex',
                alignItems: 'center',
                color: 'white',
                marginTop: '12px',
                fontWeight: 500,
                border: 'none',
              }}
            >
              <PiPencilSimpleBold />
              &nbsp;&nbsp;Edit Vydura Intake
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
